import { render } from "./FooterSection.vue?vue&type=template&id=39772829&scoped=true&ts=true"
import script from "./FooterSection.vue?vue&type=script&lang=ts"
export * from "./FooterSection.vue?vue&type=script&lang=ts"

import "./FooterSection.vue?vue&type=style&index=0&id=39772829&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39772829"]])

export default __exports__